<template>
  <div :class="this.deviceClass == 'pc' ? 'shortBox' : 'shortBoxH'">
    <component :is="currentComponent" :key="type" :detail="detail" />
  </div>
</template>

<script>
import pageModel1 from './components/pageModel1.vue'
import pageModel2 from './components/pageModel2.vue'
import pageModel3 from './components/pageModel3.vue'
import pageModel4 from './components/pageModel4.vue'
import { shareDetail } from '@/axios/home'
export default {
  components: { pageModel1, pageModel2, pageModel3, pageModel4 },
  name: 'short',
  data() {
    return {
      fshort: '',
      detail: {},
      type: null, //1是正常页面 2是被删除 3是无内容短链 4是骨架屏
    }
  },
  computed: {
    currentComponent() {
      switch (this.type) {
        case 1:
          return 'pageModel1'
        case 2:
          return 'pageModel2'
        case 3:
          return 'pageModel3'
        default:
          return 'pageModel4'
      }
    },
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
  },
  created() {
    if (this.$route.params.id) {
      this.fshort = this.$route.params.id
      sessionStorage.setItem('shortFshort', this.fshort)
      this.getShareDetail()
    }
  },
  mounted() {
    this.$store.commit('setAttr', {
      name: 'upShort',
      val: this.getShareDetail,
    })
  },
  methods: {
    async getShareDetail() {
      try {
        let res = await shareDetail({ fshort: this.fshort })
        // console.log('shareDetail', res)
        //短链状态 0-没找到短链  1-正常 2-锁定 3-删除
        if (res.status == 1) {
          if (res.data.status == 1) {
            this.type = 1
            this.detail = res.data.detail
            document.title = this.detail.url_title + ' - Fm2.cc'
          } else if (res.data.status == 2 || res.data.status == 3) {
            this.type = 2
          } else if (res.data.status == 0) {
            this.type = 3
          }
        } else {
          this.type = 3
        }
      } catch (err) {
        this.type = 3
      }
    },
  },
}
</script>
